import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getRandomDelay } from '@/modules/promo';
import { Logo } from '../../components/Logo';
import type { ScLogoProps } from '../../components/Logo/styled';
import type { FlyingElementSrc } from '../../types';
import { ScFlyingElement, ScWheelTemplate } from './styled';
import { Wheel } from './Wheel';
import { WheelRegistrationModal } from './WheelRegistrationModal';

interface WheelLandingTemplateProps extends ScLogoProps {
  backgroundImage: string;
  leftImage: string;
  rightImage: string;
  flyingElements: FlyingElementSrc[];
  wheelImage: string;
  pointerImage: string;
  wheelBackImage: string;
  backPointer: string;
  translation: string;
  darkenImage: string;
  logo?: string;
  isRegistrationIncluded?: boolean;
  characterMobile: string;
  mainRadialGradient: string;
  spinBtnBg?: string;
  link?: string;
  isLongOffer?: boolean;
}

export const WheelLandingTemplate = ({
  backgroundImage,
  leftImage,
  rightImage,
  flyingElements,
  wheelImage,
  pointerImage,
  wheelBackImage,
  backPointer,
  translation,
  darkenImage,
  isRegistrationIncluded,
  characterMobile,
  mainRadialGradient,
  logo,
  spinBtnBg,
  link,
  logoSize,
  isLongOffer,
}: WheelLandingTemplateProps) => {
  const { t } = useTranslation(translation);
  const [isModalClosed, setIsModalClosed] = useState(true);

  const handleModalState = () => {
    setIsModalClosed((prev) => !prev);
  };

  return (
    <ScWheelTemplate backgroundImage={backgroundImage}>
      <div className="main__hero">
        <Logo logoSize={logoSize} logoSrc={logo} />
        <h1>{t('spinAndGet')}</h1>
        <Wheel
          backPointer={backPointer}
          darkenImage={darkenImage}
          handleModalState={handleModalState}
          isLongOffer={isLongOffer}
          link={link}
          mainRadialGradient={mainRadialGradient}
          pointerImage={pointerImage}
          spinBtnBg={spinBtnBg}
          translation={translation}
          wheelBackImage={wheelBackImage}
          wheelImage={wheelImage}
        />
      </div>
      {flyingElements.map((element, index) => (
        <ScFlyingElement
          delay={getRandomDelay(3, 5)}
          key={index}
          posX={element.posX}
          posXMob={element.posXMob}
          posY={element.posY}
          posYMob={element.posYMob}
          src={element.src}
        />
      ))}
      <div className="main__image">
        <img alt="Left" src={leftImage} />
        <img alt="Right" src={rightImage} />
        <img alt="Mobile" className="main__img-mobile" src={characterMobile} />
      </div>
      {isRegistrationIncluded && !isModalClosed && (
        <WheelRegistrationModal
          onClose={handleModalState}
          translation={translation}
        />
      )}
    </ScWheelTemplate>
  );
};
